export default {"src":"/_next/static/media/laptopsecure.ef634a59.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};